module.exports = __webpack_public_path__ + "img/private.41bcc5b3.svg";